@if (!pageMode) {
<div class="px-6 py-4 border-b border-gray-100 bg-white flex flex-row justify-between items-start gap-4">
  <div class="min-w-0">
    <div class="flex items-center gap-3">
      <span class="h-10 w-10 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center flex-shrink-0"><mat-icon>local_offer</mat-icon></span>
      <div>
        <h1 class="text-xl font-bold text-gray-900 leading-tight">{{ isEdit ? 'Edit coupon code' : isCopy ? 'Copy of ' + data.cuopon.couponCode : 'Create new coupon code' }}</h1>
        <p class="text-xs text-gray-500">{{ isEdit ? 'Changes apply to new orders straight away' : isCopy ? 'Give the copy its own code, then adjust anything else' : 'Fill in the basics, then set any limits or restrictions' }}</p>
      </div>
    </div>
    <div class="mt-3 flex flex-wrap gap-1.5">
      @for (part of summary; track part; let first = $first) {
      <span class="text-[11px] font-semibold px-2.5 py-1 rounded-full" [class]="first ? 'bg-amber-100 text-amber-800' : 'bg-gray-100 text-gray-600'">{{ part }}</span>
      }
    </div>
  </div>
  <button type="button" (click)="finish({ status: false })"
    class="h-9 w-9 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 flex items-center justify-center text-sm transition-colors flex-shrink-0" aria-label="Close" matTooltip="Close dialog">✕</button>
</div>
}

<form [formGroup]="couponCodeAddEditFrom" (ngSubmit)="onSubmit($event)">
<mat-dialog-content class="mat-typography" [ngClass]="pageMode ? '!max-h-none !overflow-visible !p-6 bg-white rounded-2xl border border-gray-100 shadow-sm' : '!px-6 !py-5 !max-h-[62vh] !min-h-[440px]'">
  @if (loadingOptions > 0) {
  <div class="flex items-center gap-2 text-xs text-gray-500 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 mb-4">
    <span class="inline-block h-3 w-3 rounded-full border-2 border-amber-400 border-t-transparent animate-spin"></span>
    Loading customers, categories and products... you can start editing, but saving unlocks once they're in.
  </div>
  }

  <div class="flex flex-wrap gap-2 mb-5">
    <button type="button" class="flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-semibold transition-all"
      [class]="activeTab == 1 ? 'bg-neutral-900 text-white border-neutral-900 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:border-amber-300 hover:bg-amber-50'" (click)="activeTab = 1">
      <mat-icon class="!text-[18px] !h-[18px] !w-[18px]" [class]="activeTab == 1 ? '!text-amber-400' : '!text-gray-400'">tune</mat-icon>General
      @if (tabHasError(1)) { <span class="h-2 w-2 rounded-full bg-red-500"></span> }
    </button>
    <button type="button" class="flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-semibold transition-all"
      [class]="activeTab == 2 ? 'bg-neutral-900 text-white border-neutral-900 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:border-amber-300 hover:bg-amber-50'" (click)="activeTab = 2">
      <mat-icon class="!text-[18px] !h-[18px] !w-[18px]" [class]="activeTab == 2 ? '!text-amber-400' : '!text-gray-400'">rule</mat-icon>Limits & rules
      @if (tabHasError(2)) { <span class="h-2 w-2 rounded-full bg-red-500"></span> }
    </button>
    <button type="button" class="flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-semibold transition-all"
      [class]="activeTab == 3 ? 'bg-neutral-900 text-white border-neutral-900 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:border-amber-300 hover:bg-amber-50'" (click)="activeTab = 3">
      <mat-icon class="!text-[18px] !h-[18px] !w-[18px]" [class]="activeTab == 3 ? '!text-amber-400' : '!text-gray-400'">category</mat-icon>Products & categories
      @if (tabHasError(3)) { <span class="h-2 w-2 rounded-full bg-red-500"></span> }
    </button>
    <button type="button" class="flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-semibold transition-all"
      [class]="activeTab == 4 ? 'bg-neutral-900 text-white border-neutral-900 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:border-amber-300 hover:bg-amber-50'" (click)="activeTab = 4">
      <mat-icon class="!text-[18px] !h-[18px] !w-[18px]" [class]="activeTab == 4 ? '!text-amber-400' : '!text-gray-400'">redeem</mat-icon>Give away
      @if (tabHasError(4)) { <span class="h-2 w-2 rounded-full bg-red-500"></span> }
    </button>
  </div>

  <!-- General -->
  @if (activeTab == 1) {
  <div class="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-5">

    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Coupon code *</label>
      <div class="mt-2 flex gap-2">
        <input class="w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm font-mono uppercase" name="coupon-code" type="text" placeholder="e.g. SUMMER10" formControlName="couponCode" />
        @if (!isEdit) {
        <button type="button" class="px-3 rounded-xl border border-gray-200 bg-white text-xs font-semibold text-gray-700 hover:border-amber-300 hover:bg-amber-50 transition-colors whitespace-nowrap flex items-center gap-1" (click)="generateCode()" matTooltip="Make up a random code">
          <mat-icon class="!text-[16px] !h-4 !w-4">auto_awesome</mat-icon> Generate
        </button>
        }
      </div>
      @if (f['couponCode'].invalid && (f['couponCode'].dirty || f['couponCode'].touched)) {
          <div class="mt-1 text-xs text-red-500">@if (f['couponCode'].errors?.['required']) { <span>Coupon code is required</span> } @if (f['couponCode'].errors?.['minlength']) { <span>At least 2 characters</span> } @if (f['couponCode'].errors?.['maxlength']) { <span>100 characters at most</span> }</div>
          }
    </div>

    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Description *</label>
      <input class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" name="coupon-desc" type="text" placeholder="What this code is for (only staff see this)" formControlName="couponDesc" />
      @if (f['couponDesc'].invalid && (f['couponDesc'].dirty || f['couponDesc'].touched)) {
          <div class="mt-1 text-xs text-red-500">@if (f['couponDesc'].errors?.['required']) { <span>Description is required</span> } @if (f['couponDesc'].errors?.['minlength']) { <span>At least 2 characters</span> } @if (f['couponDesc'].errors?.['maxlength']) { <span>200 characters at most</span> }</div>
          }
    </div>

    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Discount *</label>
      <div class="mt-2 flex gap-2">
        <div class="flex rounded-xl border border-gray-200 bg-gray-50 p-1 flex-shrink-0">
          <label class="cursor-pointer"><input type="radio" class="sr-only peer" formControlName="couponValuetype" value="FLAT" /><span class="block px-3 py-1.5 rounded-lg text-sm font-semibold text-gray-500 peer-checked:bg-white peer-checked:text-gray-900 peer-checked:shadow-sm transition-all">£ Amount</span></label>
          <label class="cursor-pointer"><input type="radio" class="sr-only peer" formControlName="couponValuetype" value="PERC" /><span class="block px-3 py-1.5 rounded-lg text-sm font-semibold text-gray-500 peer-checked:bg-white peer-checked:text-gray-900 peer-checked:shadow-sm transition-all">% Percent</span></label>
        </div>
        <input class="w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" name="coupon-value" type="number" min="0" step="0.01" placeholder="Value" formControlName="couponValue" />
      </div>
      @if (f['couponValue'].invalid && (f['couponValue'].dirty || f['couponValue'].touched)) {
          <div class="mt-1 text-xs text-red-500">@if (f['couponValue'].errors?.['required']) { <span>Discount is required</span> } @if (f['couponValue'].errors?.['min']) { <span>Can not be negative</span> } @if (f['couponValue'].errors?.['maxPerc']) { <span>A percentage can not be over 100</span> }</div>
          }
    </div>

    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Expiry</label>
      <div class="mt-2 flex items-center gap-3">
        <input class="w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-40" name="coupon-expire-date" type="date" formControlName="expiryDate" [attr.min]="isEdit ? null : today" [class.opacity-40]="noExpiry" [attr.disabled]="noExpiry ? '' : null" />
        <label class="flex items-center gap-2 text-sm text-gray-700 whitespace-nowrap cursor-pointer">
          <input type="checkbox" class="h-4 w-4 accent-amber-500" [(ngModel)]="noExpiry" [ngModelOptions]="{ standalone: true }" /> No expiry
        </label>
      </div>
    </div>

    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Only for this customer</label>
          <div class="mt-2">
            <app-multi-select-typehead
              [options]="customers"
              [mainDisplayKey]="'firstname'"
              [keysToMatch]="['displayname','firstname', 'lastname' ]"
              [extraDisplayKey]="'lastname'"
              [idKey]="'userid'"
              [prevData]="selectedCustomers"
              (onModelChangedEvent)="onCustomerSelection($event)"
            ></app-multi-select-typehead>
          </div>
        </div>

    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Associated codes</label>
      <select class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm !h-[92px]" multiple [(ngModel)]="selectedAssociatedCodes" [ngModelOptions]="{ standalone: true }">
        @for (coupon of giveAwayCouponsList; track coupon.id) {
          <option [value]="coupon.id">{{ coupon.couponCode }}</option>
        }
      </select>
      <p class="mt-1 text-xs text-gray-400">Free-gift codes that come with this one. Hold Ctrl / Cmd to pick several.</p>
    </div>
  </div>
  }

  <!-- Limits & rules -->
  @if (activeTab == 2) {
  <div class="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-5">
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Minimum spend (£)</label>
          <input class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" name="min-spend" type="number" min="0" placeholder="0" formControlName="minSpend" />
          <p class="mt-1 text-xs text-gray-400">0 means no minimum</p>
          @if (f['minSpend'].invalid && (f['minSpend'].dirty || f['minSpend'].touched)) {
          <div class="mt-1 text-xs text-red-500">@if (f['minSpend'].errors?.['required']) { <span>Minimum spend is required</span> } @if (f['minSpend'].errors?.['min']) { <span>Must be 0 or more</span> }</div>
          }
        </div>
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Maximum spend (£)</label>
          <input class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" name="max-spend" type="number" min="0" placeholder="0" formControlName="maxSpend" />
          <p class="mt-1 text-xs text-gray-400">0 means no maximum</p>
          @if (f['maxSpend'].invalid && (f['maxSpend'].dirty || f['maxSpend'].touched)) {
          <div class="mt-1 text-xs text-red-500">@if (f['maxSpend'].errors?.['required']) { <span>Maximum spend is required</span> } @if (f['maxSpend'].errors?.['min']) { <span>Must be 0 or more</span> }</div>
          }
        </div>
    @if (spendRangeInvalid) {
    <div class="md:col-span-2 -mt-2 text-xs text-red-500">Maximum spend is lower than the minimum spend, so this code could never apply.</div>
    }
    <div class="md:col-span-2">
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Spend is measured on</label>
      <div class="mt-2 grid grid-cols-2 gap-3">
        <label class="flex items-start gap-3 p-3.5 rounded-xl border bg-white hover:border-amber-300 cursor-pointer transition-colors"
          [class]="f['priceRangeApplyTo'].value === 'ORDER_VALUE' ? 'border-amber-400 bg-amber-50/60' : 'border-gray-200'">
          <input type="radio" class="mt-0.5 h-4 w-4 accent-amber-500" formControlName="priceRangeApplyTo" value="ORDER_VALUE" />
          <span><span class="block text-sm font-semibold text-gray-800">Order value</span><span class="block text-xs text-gray-500 mt-0.5">The basket before other discounts</span></span>
        </label>
        <label class="flex items-start gap-3 p-3.5 rounded-xl border bg-white hover:border-amber-300 cursor-pointer transition-colors"
          [class]="f['priceRangeApplyTo'].value === 'NET_TOTAL' ? 'border-amber-400 bg-amber-50/60' : 'border-gray-200'">
          <input type="radio" class="mt-0.5 h-4 w-4 accent-amber-500" formControlName="priceRangeApplyTo" value="NET_TOTAL" />
          <span><span class="block text-sm font-semibold text-gray-800">Net total</span><span class="block text-xs text-gray-500 mt-0.5">After other discounts are taken off</span></span>
        </label>
      </div>
    </div>
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Total uses</label>
          <input class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" name="coupon-uses" type="number" min="0" placeholder="0" formControlName="useTimes" />
          <p class="mt-1 text-xs text-gray-400">0 means unlimited</p>
          @if (f['useTimes'].invalid && (f['useTimes'].dirty || f['useTimes'].touched)) {
          <div class="mt-1 text-xs text-red-500">@if (f['useTimes'].errors?.['required']) { <span>Required</span> } @if (f['useTimes'].errors?.['min']) { <span>Must be 0 or more</span> }</div>
          }
        </div>
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Uses per customer</label>
          <input class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" name="coupon-uses-customer" type="number" min="0" placeholder="0" formControlName="useTimesCustomer" />
          <p class="mt-1 text-xs text-gray-400">0 means unlimited</p>
          @if (f['useTimesCustomer'].invalid && (f['useTimesCustomer'].dirty || f['useTimesCustomer'].touched)) {
          <div class="mt-1 text-xs text-red-500">@if (f['useTimesCustomer'].errors?.['required']) { <span>Required</span> } @if (f['useTimesCustomer'].errors?.['min']) { <span>Must be 0 or more</span> }</div>
          }
        </div>

    <div class="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-3">
        <label class="flex items-start gap-3 p-3.5 rounded-xl border border-gray-200 bg-white hover:border-amber-300 hover:bg-amber-50/40 cursor-pointer transition-colors">
          <input type="checkbox" class="mt-0.5 h-4 w-4 accent-amber-500" formControlName="individualUse" />
          <span><span class="block text-sm font-semibold text-gray-800">Individual use only</span><span class="block text-xs text-gray-500 mt-0.5">Can not be combined with another code</span></span>
        </label>
        <label class="flex items-start gap-3 p-3.5 rounded-xl border border-gray-200 bg-white hover:border-amber-300 hover:bg-amber-50/40 cursor-pointer transition-colors">
          <input type="checkbox" class="mt-0.5 h-4 w-4 accent-amber-500" formControlName="excludeSales" />
          <span><span class="block text-sm font-semibold text-gray-800">Exclude sale items</span><span class="block text-xs text-gray-500 mt-0.5">The discount skips items already on sale</span></span>
        </label>
        <label class="flex items-start gap-3 p-3.5 rounded-xl border border-gray-200 bg-white hover:border-amber-300 hover:bg-amber-50/40 cursor-pointer transition-colors">
          <input type="checkbox" class="mt-0.5 h-4 w-4 accent-amber-500" formControlName="invalidateTradeDiscounts" />
          <span><span class="block text-sm font-semibold text-gray-800">Cancel trade discounts</span><span class="block text-xs text-gray-500 mt-0.5">Trade pricing is removed when this code is applied</span></span>
        </label>
        <label class="flex items-start gap-3 p-3.5 rounded-xl border border-gray-200 bg-white hover:border-amber-300 hover:bg-amber-50/40 cursor-pointer transition-colors">
          <input type="checkbox" class="mt-0.5 h-4 w-4 accent-amber-500" formControlName="internalUseOnly" />
          <span><span class="block text-sm font-semibold text-gray-800">Staff only</span><span class="block text-xs text-gray-500 mt-0.5">Only admins and sales agents can apply it</span></span>
        </label>
    </div>

    <div class="md:col-span-2">
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Customer types that can use it</label>
      <div class="mt-2 flex flex-wrap items-center gap-2">
        <select class="w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm !w-48" formControlName="selectedUserRoleToAdd">
          <option value="ALL">All types</option>
          @for (role of roleOptions; track role) { <option [value]="role">{{ role }}</option> }
        </select>
        <button type="button" class="px-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm font-semibold text-gray-700 hover:border-amber-300 hover:bg-amber-50 transition-colors" (click)="onAddUserRole()">Add</button>
        @for (item of couponValidUserRoles; track item; let i = $index) {
          <span class="inline-flex items-center gap-1.5 text-xs font-semibold rounded-full pl-3 pr-1.5 py-1 bg-amber-100 text-amber-800">
            {{ item }}
            <button type="button" (click)="onDeleteUserRoleFromList(i)" class="h-4 w-4 rounded-full bg-amber-200 hover:bg-red-500 hover:text-white flex items-center justify-center" [attr.aria-label]="'Remove ' + item"><mat-icon class="!text-[12px] !h-3 !w-3">close</mat-icon></button>
          </span>
        }
        @if (couponValidUserRoles.length === 0) { <span class="text-xs text-gray-400">Nobody is excluded - every customer type can use it.</span> }
      </div>
    </div>
  </div>
  }

  <!-- Products & categories -->
  @if (activeTab == 3) {
  <p class="text-xs text-gray-500 mb-4">Leave everything empty and the code works on the whole basket. Picking items under "only" limits the discount to them; "excluded" items never get it.</p>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-5">
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Only these products</label>
          <div class="mt-2">
            <app-multi-select-typehead
              [options]="products"
              [mainDisplayKey]="'productName'"
              [keysToMatch]="['productName','productSlug']"
              [nestedArrayKeysToMatch]="[{arrayKey: 'productvariants', keyInArray: 'sku'}]"
              [idKey]="'productId'"
              [prevData]="selectedProductsInclude"
              (onModelChangedEvent)="onProductIncludeSelection($event)"
            ></app-multi-select-typehead>
          </div>
        </div>
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Never these products</label>
          <div class="mt-2">
            <app-multi-select-typehead
              [options]="products"
              [mainDisplayKey]="'productName'"
              [keysToMatch]="['productName','productSlug']"
              [nestedArrayKeysToMatch]="[{arrayKey: 'productvariants', keyInArray: 'sku'}]"
              [idKey]="'productId'"
              [prevData]="selectedProductsExclude"
              (onModelChangedEvent)="onProductExcludeSelection($event)"
            ></app-multi-select-typehead>
          </div>
        </div>
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Only these categories</label>
          <div class="mt-2">
            <app-multi-select-typehead
              [options]="categories"
              [mainDisplayKey]="'categoryName'"
              [keysToMatch]="['categoryName','categorySlug']"
              [idKey]="'categoryId'"
              [prevData]="selectedCategoriesInclude"
              (onModelChangedEvent)="onCategoryIncludeSelection($event)"
            ></app-multi-select-typehead>
          </div>
        </div>
    
        <div>
          <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Never these categories</label>
          <div class="mt-2">
            <app-multi-select-typehead
              [options]="categories"
              [mainDisplayKey]="'categoryName'"
              [keysToMatch]="['categoryName','categorySlug']"
              [idKey]="'categoryId'"
              [prevData]="selectedCategoriesExclude"
              (onModelChangedEvent)="onCategoryExcludeSelection($event)"
            ></app-multi-select-typehead>
          </div>
        </div>
  </div>
  }

  <!-- Give away -->
  @if (activeTab == 4) {
  <label class="flex items-start gap-3 p-3.5 rounded-xl border border-gray-200 bg-white hover:border-amber-300 hover:bg-amber-50/40 cursor-pointer transition-colors">
    <input type="checkbox" class="mt-0.5 h-4 w-4 accent-amber-500" [(ngModel)]="giveAwayEnabled" [ngModelOptions]="{ standalone: true }" />
    <span><span class="block text-sm font-semibold text-gray-800">This code comes with a free gift</span><span class="block text-xs text-gray-500 mt-0.5">The customer picks from the products you list here</span></span>
  </label>

  @if (giveAwayEnabled) {
  <div class="mt-5 grid grid-cols-1 md:grid-cols-2 gap-5">
    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">How many they can pick</label>
      <select class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm" [(ngModel)]="giveAwayType" [ngModelOptions]="{ standalone: true }">
        @for (n of [1,2,3,4,5,6,7,8,9,10]; track n) { <option [value]="'POPUP_' + n + '_PROD_SELECTION'">Popup - customer selects {{ n }} product{{ n === 1 ? '' : 's' }}</option> }
      </select>

      @if (giveAwaySingleProdSelectionProds.length > 0) {
      <h4 class="mt-5 text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Gifts on offer ({{ giveAwaySingleProdSelectionProds.length }})</h4>
      <div class="mt-2 flex flex-col gap-2">
        @for (prodVariant of giveAwaySingleProdSelectionProds; track prodVariant.variantSku; let i = $index) {
        <div class="flex items-center justify-between gap-2 border border-gray-100 bg-gray-50 rounded-xl px-3 py-2">
          <div class="min-w-0"><div class="text-sm font-semibold text-gray-800 truncate">{{ prodVariant.productName }}</div><div class="text-xs text-gray-500">{{ prodVariant.variantSku }}</div></div>
          <button type="button" class="h-8 w-8 rounded-full text-gray-400 hover:bg-red-50 hover:text-red-600 flex items-center justify-center flex-shrink-0" (click)="onRemoveGiveAwayProduct(i)" aria-label="Remove"><mat-icon class="!text-[18px]">delete</mat-icon></button>
        </div>
        }
      </div>
      } @else {
      <p class="mt-4 text-xs text-gray-400">No gifts chosen yet - add at least one, or nothing will be saved.</p>
      }
    </div>

    <div>
      @if (isPopupProdSelectionType()) {
      <div class="rounded-2xl border border-gray-100 p-4">
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Add products to the gift list</label>
        <div class="mt-2">
          <app-typehead [dataSet]="productSuggestionList" [keysToMatch]="['name','sku']" (onModelChangedEvent)="onMotherProductSelection($event)" [resetEachSelect]="true"></app-typehead>
        </div>
        @if (giveAwayCurrentProductSelection) {
        <div class="mt-4 rounded-xl bg-gray-50 border border-gray-100 p-3">
          <h4 class="text-sm font-semibold text-gray-800">{{ giveAwayCurrentProductSelection.productName }}</h4>
          <p class="text-xs text-gray-500">{{ giveAwayCurrentVariantSelection.length }} variant(s) selected</p>
          <div class="mt-2 flex flex-col gap-1 max-h-48 overflow-y-auto">
            @for (prodVariant of giveAwayCurrentProductSelection.productvariants; track prodVariant.sku) {
            <label class="flex items-center gap-2 text-xs text-gray-700 px-2 py-1.5 rounded-lg hover:bg-white cursor-pointer">
              <input type="checkbox" class="accent-amber-500" [checked]="giveAwayCurrentVariantSelection.includes(prodVariant.sku)" (change)="onVariantCheckChange(prodVariant.sku, $event)" />
              {{ prodVariant.sku }}
            </label>
            }
          </div>
          <button type="button" class="mt-3 w-full py-2 rounded-xl bg-neutral-900 text-white text-sm font-semibold hover:bg-neutral-700 transition-colors disabled:opacity-40" [disabled]="giveAwayCurrentVariantSelection.length === 0" (click)="addProductToGiveAwayList()">Add to gift list</button>
        </div>
        }
      </div>
      }
    </div>
  </div>
  }
  }
</mat-dialog-content>

<div class="flex flex-row items-center justify-between gap-3" [ngClass]="pageMode ? 'sticky bottom-4 z-20 mt-6 px-5 py-3 rounded-2xl border border-gray-200 shadow-lg bg-white/95 backdrop-blur' : 'px-6 py-4 border-t border-gray-100 bg-white'">
  <span class="text-xs" [ngClass]="pageMode && (spendRangeInvalid || couponCodeAddEditFrom.invalid) ? 'text-amber-700 font-semibold' : 'text-gray-400'">{{ spendRangeInvalid ? 'Check the spend limits' : couponCodeAddEditFrom.invalid ? 'Some required fields still need filling in' : '' }}</span>
  <div class="flex gap-3">
    <button type="button" (click)="finish({ status: false })" class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors">{{ pageMode ? 'Back to list' : 'Cancel' }}</button>
    <button type="submit" [disabled]="couponCodeAddEditFrom.invalid || spendRangeInvalid || saving"
      class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none">
      @if (saving) { <span class="inline-block h-4 w-4 rounded-full border-2 border-neutral-900 border-t-transparent animate-spin"></span> }
      {{ isEdit ? 'Update coupon' : 'Save coupon' }}
    </button>
  </div>
</div>
</form>
